module.exports = __webpack_public_path__ + "static/media/Double Matting Vertical.faad6c60.png";